import { render, staticRenderFns } from "./Aneel10.vue?vue&type=template&id=04ed2ca0&"
import script from "./Aneel10.vue?vue&type=script&lang=js&"
export * from "./Aneel10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports